import { render } from "./MyPageReply.vue?vue&type=template&id=675306bd"
import script from "./MyPageReply.vue?vue&type=script&lang=js"
export * from "./MyPageReply.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__